import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { UIModel } from '../../../../models/core/ui/ui.model';
import { GlobalErrorHandler } from '../../../../services/error.handler';

@Component({
  selector: 'app-board-not-found',
  templateUrl: './board-not-found.component.html',
  styleUrls: ['./board-not-found.component.scss']
})
export class BoardNotFoundComponent implements OnInit {

  /**
   * Gets or sets animation options for lottie.
   */
  public animationOptions: AnimationOptions = {
    path: UIModel.notFoundErrorAnimationUrl
  };

  /**
   * Gets or sets exception message.
   */
  public exceptionMessage: string | undefined;

  constructor() { }

  public ngOnInit(): void {
    // Reset error as user should be able to navigate back
    // with this error.
    GlobalErrorHandler.isFatalError = false;
    GlobalErrorHandler.fatalError = undefined;
  }

}
